import { WSService } from "../../../utils/WSService";
import type { onboardingApiSpec } from "@wingspanhq/wingspan-api-types";

const service = new WSService("/v2/onboarding/missing-data");

export const getVerificationMissingData = async (
  verificationLevel: onboardingApiSpec.operations["getVerificationMissingData"]["parameters"]["path"]["verificationLevel"]
): Promise<
  onboardingApiSpec.operations["getVerificationMissingData"]["responses"]["200"]["content"]["application/json"]
> => {
  const { data } = await service.get("/" + verificationLevel);
  return data;
};
